import { useEffect, useRef, useCallback } from 'react';
import io from 'socket.io-client';
import { SOCKET_URL } from '../services/api';

export function useTickerSocket(gameId, { onEvent, onUpdate, onDelete, onScore, onStatus } = {}) {
    const socketRef = useRef(null);

    useEffect(() => {
        if (!gameId) return;

        const socket = io(SOCKET_URL, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 10,
        });

        socketRef.current = socket;

        socket.on('connect', () => {
            socket.emit('ticker:join', gameId);
        });

        socket.on('ticker:event', (data) => {
            if (onEvent) onEvent(data);
        });

        socket.on('ticker:update', (data) => {
            if (onUpdate) onUpdate(data);
        });

        socket.on('ticker:delete', (data) => {
            if (onDelete) onDelete(data);
        });

        socket.on('ticker:score', (data) => {
            if (onScore) onScore(data);
        });

        socket.on('ticker:status', (data) => {
            if (onStatus) onStatus(data);
        });

        socket.on('disconnect', () => {
            console.log('Ticker socket disconnected');
        });

        return () => {
            socket.emit('ticker:leave', gameId);
            socket.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameId]);

    const emit = useCallback((event, data) => {
        if (socketRef.current) {
            socketRef.current.emit(event, data);
        }
    }, []);

    return { emit };
}
